<template>
  <div>
    <Header></Header>
    <div class="nodeBanner">
      <div class="node">
        <div class="nodeContent">
          <div class="bannerTitle">全省监测</div>
          <div class="bannerContent">
            采集省内二级节点数据，将数据进行过滤、筛选、整合、重塑等操作，最终形成有效的数据对外展示。当前平台从体系架构，数据监测，服务监测，安全监测这四方面提供一套完整的监测体系。</div>
        </div>
        <div class="searchBlock">
          <div class="title">标识查询</div>
          <div class="searchInner">
            <input type="text" v-model="searchValue" class="searchInput" placeholder="请输入您要查询的标识" />
            <button style="cursor: pointer;" @click="handleSearch"><img src="../../assets/images/icon_ss@2x.png" />查询</button>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 700px;padding-top: 150px;box-sizing: border-box;">
      <div class="systemTitle">监测体系</div>
      <div class="systemList">
        <div v-for="(item, index) in systemList" :key="index">
          <div>
            <img class="img1" :src="item.img" :style="{'width': item.width + 'px'},{'height': item.height + 'px'}">
            <img class="img2" :src="item.img1" :style="{'width': item.width + 'px'},{'height': item.height + 'px'}">
            <div class="title">{{item.title}}</div>
            <div class="content">{{item.content}}</div>
            <img class="img3" :src="item.img2" :style="{'width': item.width1 + 'px'},{'height': item.height1 + 'px'}"
              style="position: absolute;bottom: 0;right: 0;">
          </div>
        </div>
      </div>

    </div>
    <Contact />
    <!--页脚-->
    <Footer />

    <el-dialog :visible.sync="visible" :show-close="false">
      <div class="searchDialog">
        <div class="dialogTop">
          <!-- <span class="tabMenu" :class="tab === 1 ? 'active' : ''" @click="tabChange(1)">前缀注册信息</span> -->
          <span class="border"></span>
          <span class="tabMenu" :class="tab === 2 ? 'active' : ''" @click="tabChange(2)">标识解析数据</span>
          <span class="closeBtn" @click="closeDialog">关闭</span>
        </div>
        <div class="dialogBody">
          <div class="bodyTop">
            <span>{{searchValue}}</span>
          </div>
          <div class="bodyTit">
            <span class="myIcon"></span><span v-if="tab === 1">企业信息</span><span v-else>标识解析数据</span>
          </div>
          <!-- <div class="compayList" v-if="tab === 1">
            <div>
              <div class="lable">单位名称:</div>
              <div class="value">清控数联（山西）工业技术有限公司</div>
            </div>
            <div>
              <div class="lable">单位前缀:</div>
              <div class="value">86.122.2</div>
            </div>
            <div>
              <div class="lable">官网地址:</div>
              <div class="value">https://www.idshanxi.com</div>
            </div>
            <div>
              <div class="lable">所属地域:</div>
              <div class="value">山西省/太原市/小店区</div>
            </div>
            <div>
              <div class="lable">所属行业:</div>
              <div class="value">信息传输、软件和信息技术服务业/软件和信息技术服务业/</div>
            </div>
            <div>
              <div class="lable">单位地址:</div>
              <div class="value">山西综改示范区太原唐槐园区康寿街11号科技创新孵化基地4号楼501A室</div>
            </div>
          </div> -->
          <div class="handleList" v-if="handeleList.length > 0">
            <div v-for="(item, index) in handeleList" :key="index">
              <div class="label">{{item.key}}:</div>
              <div class="value">{{item.value}}</div>
            </div>
            <!-- <div>
              <div class="label">时间：</div>
              <div class="value">2022-10-10 10:26:12</div>
            </div>
            <div>
              <div class="label">名称：</div>
              <div class="value">自定义页面</div>
            </div>
            <div>
              <div class="label">网址：</div>
              <div class="value">https://api.86122m.com/h?h=86.122.2/L6MZBNbX5o</div>
            </div>
            <div>
              <div class="label">标题：</div>
              <div class="value">核辐射设备</div>
            </div> -->
          </div>
          <div v-else class="noneData">
            暂无数据!
          </div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'
  import Contact from './Contact.vue'
  import {
    serverUrl
  } from '@/utils/server.js'
  import {
    getHandleList
  } from '@/api/api.js'
  export default {
    data() {
      return {
        handeleList: [],
        searchValue: '',
        tab: 2,
        visible: false,
        scroll: 'home',
        systemList: [{
          with: 33,
          height: 33,
          img: require("../../assets/images/icon_tx@2x.png"),
          img1: require("../../assets/images/tx2@2x.png"),
          title: '体系架构',
          content: '体系架构内容包括标识解析流程，标识注册流程，省内、全国节点分布情况。',
          img2: require("../../assets/images/icon_tx3@2x.png"),
          with1: 117,
          height1: 127,
        }, {
          with: 36,
          height: 34,
          img: require("../../assets/images/icon_sj@2x.png"),
          img1: require("../../assets/images/icon_sj2@2x.png"),
          title: '数据监测',
          content: '数据监测从企业维度、行业维度、 区域维度对节点标识注册量和解析 量进行统计。',
          img2: require("../../assets/images/icon_sj3@2x.png"),
          with1: 115,
          height1: 134,
        }, {
          with: 43,
          height: 33,
          img: require("../../assets/images/icon_fwq@2x.png"),
          img1: require("../../assets/images/icon_fwq2@2x.png"),
          title: '服务监测',
          content: '服务监测主要监听服务器实时运行 情况，监听项包括CPU，内存，磁 盘，端口。',
          img2: require("../../assets/images/icon_fwq3@2x.png"),
          with1: 123,
          height1: 99,
        }, {
          with: 27,
          height: 33,
          img: require("../../assets/images/icon-aq@2x.png"),
          img1: require("../../assets/images/icon-aq2@2x.png"),
          title: '安全监测',
          content: '安全监测是对支撑二级节点运行的 各个子服务的监测。',
          img2: require("../../assets/images/icon-aq3@2x.png"),
          with1: 113,
          height1: 126,
        }]
      }
    },
    components: {
      Header,
      Footer,
      Contact
    },
    created() {

    },
    methods: {
      setScroll(eId) {
        this.scroll = eId
      },
      tabChange(num) {
        this.tab = num
      },
      closeDialog() {
        this.searchValue = ''
        this.visible = false
      },
      handleSearch() {
        if (!this.searchValue) {
          return this.$message({
          message: '请输入您要查询的标识',
          type: 'warning'
        });
        }
        this.visible = true
        getHandleList({handle: this.searchValue}).then(res => {
          console.log(JSON.stringify(res))
          this.handeleList = res.data
        })
      }
    }
  }
</script>

<style scoped>
  .nodeBanner {
    width: 100%;
    height: 757px;
    background: url('../../assets/images/nodeBanner@2x.png') top center no-repeat;
    background-size: cover;
    position: relative;
    display: flex;
    justify-content: center;
  }

  .searchBlock {
    width: 1366px;
    height: 181px;
    background: url('../../assets/images/bj_c@2x.png') top center no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
    position: absolute;
    bottom: -106px;
    /* margin-top: -100px; */
  }

  .searchBlock .title {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #2A93FF;
    text-align: center;
    padding-top: 25px;
  }

  .searchInner {
    width: 1213px;
    height: 56px;
    border: 1px solid #C4CFDE;
    border-radius: 28px;
    margin: 20px auto 0;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .searchInner input {
    height: 46px;
    width: 87%;
    padding-left: 20px;
    border: none;
    background-color: transparent;
  }

  .searchInner button {
    width: 130px;
    height: 46px;
    background: #2A93FF;
    border-radius: 23px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    border: none;
    outline: none;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .searchInner button img {
    width: 22px;
    height: 22px;
    margin-right: 10px;
  }

  .node {
    width: 1373px;
    margin: 0 auto;
    display: flex;
    align-items: center;
  }

  .nodeContent {
    width: 655px;
  }

  .bannerTitle {
    font-size: 48px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FEFEFF;
    line-height: 36px;
  }

  .bannerContent {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FEFEFF;
    line-height: 32px;
    margin-top: 54px;
  }

  .systemList {
    width: 1272px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    /* align-items: center; */
  }

  .systemTitle {
    text-align: center;
    font-size: 40px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #1B222C;
    line-height: 24px;
    margin-bottom: 100px;
  }

  .systemList>div {
    width: 318px;
    height: 281px;
    padding: 58px 25px 30px;
    box-sizing: border-box;
    position: relative;
  }

  .systemList>div .content {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #8F99AB;
    line-height: 27px;
  }

  .systemList>div .title {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #1B222C;
    line-height: 24px;
    margin: 30px 0;
  }

  .systemList>div:nth-child(1) {
    background: #F8F8F8;
  }

  .systemList>div:nth-child(2) {
    background: #F1F1F1;
  }

  .systemList>div:nth-child(3) {
    background: #F8F8F8;
  }

  .systemList>div:nth-child(4) {
    background: #F1F1F1;
  }

  .systemList>div:hover {
    width: 318px;
    height: 343px;
    background: #0F5BE8;
    top: -30px
  }

  .systemList>div .img2 {
    display: none;
  }

  .systemList>div:hover .img1 {
    display: none;
  }

  .systemList>div:hover .img2 {
    display: block;
  }

  .systemList>div:hover .content {
    color: #fff;
  }

  .systemList>div:hover .title {
    color: #fff;
  }


  .searchDialog {
    width: 1300px;
    height: 500px;
    overflow-x: hidden;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    margin: 0 auto;
    padding-bottom: 20px;
    position: relative;

  }

  .dialogTop {
    background: #e2eaff;
    text-align: center;
    font-size: 20px;
    position: fixed;
    /* top: 0px; */
    width: 1300px;
    padding: 10px 0;
    z-index: 999;
  }

  .dialogTop .tabMenu:nth-child(1) {
    border-right: 1px solid #ccc;
  }

  .tabMenu {
    padding: 5px 20px;
    display: inline-block;
  }

  .tabMenu.active {
    color: #15a3fe;
    font-weight: 700;
    /* border-bottom: 1px solid #15a3fe; */
  }

  .closeBtn {
    position: absolute;
    font-size: 16px;
    color: #01c3fe;
    cursor: pointer;
    right: 20px;
    top: 20px;
  }

  .dialogBody {
    padding: 0 10px;
  }

  .bodyTop {
    font-size: 22px;
    border-bottom: 1px solid #ccc;
    position: relative;
    height: 50px;
    line-height: 60px;
    overflow: hidden;
  }

  .bodyTop::before {
    width: 100px;
    content: "";
    display: block;
    height: 1px;
    background: #15a3fe;
    position: absolute;
    bottom: 0;
    left: 0;
  }

  .bodyTit {
    width: 1300px;
    font-size: 16px;
    line-height: 30px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 20px 0 10px 0;
  }

  .myIcon {
    width: 20px;
    height: 10px;
    box-shadow: 0 -10px 0 0 #ccc;
    background: #0096ff;
    display: inline-block;
    margin-right: 10px;
  }

  .compayList {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    background: #f6f6f6;
    /* padding: 10px; */
  }

  .compayList>div {
    width: 50%;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
    padding: 10px 0;
  }

  .compayList .lable {
    font-size: 14px;
    color: #606266;
    width: 88px;
    /* padding-right: 20px; */
    padding-left: 50px;
  }

  .compayList .value {
    font-size: 14px;
    color: #303030;
  }

  .handleList {
    width: 1300px;
    font-size: 14px;
    color: #303030;
  }

  .handleList .label {
    width: 120px;
    padding-right: 20px;
    padding-left: 50px;
  }

  .handleList>div {
    padding: 10px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .handleList>div:nth-child(odd) {
    background: #f6f6f6;
  }

  /deep/ .el-dialog {
    width: 1344px;
  }

  /deep/ .el-dialog__header {
    padding: 0;
  }

  .noneData {
    text-align: center;
    font-size: 36px;
    margin: 40px 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/node/NodePage.vue